<template>
  <div class="infoTable mb-3">
    <v-layout row wrap>
      <v-flex xs12>
        <v-icon small class="k-orange-linear-text mb-1">fas fa-file-invoice-dollar</v-icon>
        <span class="subheading font-weight-medium">Saldos</span>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-2>
      <v-flex md3>
        <small>{{ amountDueBalance }}</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.due_balance || 0) || 'Sin especificar' }}</p>
      </v-flex>
      <v-flex md3>
        <small>{{ amountInvoicedBalance }}</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.invoiced_balance || 0) || 'Sin especificar' }}</p>
      </v-flex>
      <v-flex md3>
        <small>{{ amountTotalBalance }}</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.total_balance || 0) || 'Sin especificar' }}</p>
      </v-flex>
      <v-flex md3>
        <small>{{ amountPrincipalBalance }}</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.principal_balance || 0) || 'Sin especificar' }}</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md3>
        <small>Saldo Provisionado</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.provision_balance || 0) || 'Sin especificar' }}</p>
      </v-flex>
      <v-flex md3>
        <small>Saldo Pagado</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.paid_balance || 0) || 'Sin especificar' }}</p>
      </v-flex>
      <v-flex md3>
        <small>Saldo del Prestamo</small>
        <br />
        <p
          class="caption"
        >{{ '$' + new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2 } ).format(customer.loan_amount || 0) || 'Sin especificar' }}</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    amountDueBalance() {
      let name = 'Saldo de Deuda';
      // if (this.$auth.user().company.id === 3393039) {
      //   name = 'Saldo Pago Minimo';
      // }
      return name;
    },
    amountInvoicedBalance() {
      let name = 'Saldo Facturado';
      // if (this.$auth.user().company.id === 3393039) {
      //   name = 'Saldo Deuda Vencida';
      // }
      return name;
    },
    amountTotalBalance() {
      let name = 'Saldo Total';
      // if (this.$auth.user().company.id === 3393039) {
      //   name = 'Saldo Deuda Total';
      // }
      return name;
    },
    amountPrincipalBalance() {
      let name = 'Saldo Capital';
      // if (this.$auth.user().company.id === 3393039) {
      //   name = 'Saldo Pago Menor';
      // }
      return name;
    },
  },
};
</script>

<style scoped lang="css">
  .infoTable {
    border: 1px solid #d0c9c9;
    border-width: 0.5px;
    padding: 4px 2em;
  }
</style>


// WEBPACK FOOTER //
// src/components/customer/BalanceInfo.vue